import { Box } from '@mui/material';
import React, { useState, useEffect } from 'react';

const PageTitle = ({ pageTitle, titleText = null }) => {
  const [title, setTitle] = useState(null);

  useEffect(() => {
    document.title = pageTitle;
    setTitle(titleText ?? pageTitle);
  }, [pageTitle, titleText]);

  return (
    <Box id="pageTitle">
      <h1>{title}</h1>
    </Box>
  );
};

export default PageTitle;
